import * as ents from '@attain-apps/entities'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjsUtils from '@attain-apps/rxjs-utils'
import * as rxjs from 'rxjs'

import type { Feature } from '../../feature'
import { getNodeDataDefinition } from '../elements'
import type { Manager } from '../manager'
import { refreshNodeClasses } from '../setup'

export const saveEditsToCytoscape = store.effects.create(
  (feature: Feature, manager: Manager) =>
    feature.actions.saveEdits.success.observe().pipe(
      rxjsUtils.latestFrom(
        ({
          data: {
            request: { chartId: orgChartId },
          },
        }) => ({
          nodes: feature.selectors.getNodes({ chartId: orgChartId })
            .asObservable,
          orgChartId: rxjs.of(orgChartId),
        }),
      ),
      rxjs.map(({ nodes, orgChartId }) => {
        const cy = manager.getInstance({ chartId: orgChartId })
        if (!cy || !nodes.length) {
          return
        }
        // Writes the data of all nodes because we don't know which one(s) were
        // edited
        for (const node of nodes) {
          cy.getElementById(ents.core.display.tree.Node.Id.get(node)).data(
            getNodeDataDefinition(node),
          )
        }

        refreshNodeClasses(cy, {
          chartId: orgChartId,
          feature,
        })
      }),
      rxjs.ignoreElements(),
    ),
)
